// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "aiyuceng/js/" + chunkId + "." + {"95":"e3423ee0","526":"3ec32bad","811":"f92f5528"}[chunkId] + ".js";
};